export default class FillMethod {
  /**
   * Constructs a new third party fill method
   * @param name equivelant bidder name, e.g. 'nativebidder'
   * @param bidder prebid bidders compatible config object
   * @param estValue average CPM value for sorting by price priority for load order
   */
  constructor (name, bidder, format, estValue = 0.01) {
    this._name = name
    this._bidder = bidder
    this._format = format
    this._estValue = estValue
  }

  name () {
    return this._name
  }

  /**
   * Return media format: banner, video, or native
   */
  format () {
    return this._format
  }

  /**
   * Should attempt to fill an ad unit and complete a promise with
   * the value or estimated value in CPM of the impression
   * @param slot
   * @param media
   * @returns {Promise<never>} completed with bid object value if cleared, or 0 if no fill, should
   * reject only if an error occurs that may affect fill flow
   */
  fill (slot, media) {
    return Promise.reject(Error('Override FillMethod.run'))
  }

  estValue () {
    return this._estValue
  }
}
